import i18n, { type Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export interface I18nConfig {
  resources: Resource;
  fallbackLng?: string;
  supportedLngs?: string[];
}

export function initI18n(config: I18nConfig) {
  const {
    resources,
    fallbackLng = 'en',
    supportedLngs = ['en', 'de'],
  } = config;

  const instance = i18n.createInstance();

  instance
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng,
      supportedLngs,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['cookie', 'navigator'],
        caches: ['cookie'],
        cookieDomain: '.referee.app',
        cookieMinutes: 525600,
        cookieOptions: { path: '/', sameSite: 'strict' },
      },
    });

  // Keep <html lang> in sync with the active language. The SPA index.html files ship a static
  // lang="en", so without this the document claims English while rendering German — which makes
  // Chrome offer to "translate" German into German, and makes screen readers apply English
  // pronunciation to German text.
  if (typeof document !== 'undefined') {
    // resolvedLanguage, not language: `language` may be a region-tagged value (e.g. 'de-DE') that
    // is not in supportedLngs, while resolvedLanguage is the one whose strings actually render.
    const syncDocumentLang = () => {
      const lng = instance.resolvedLanguage;
      if (lng) {
        document.documentElement.lang = lng;
      }
    };

    instance.on('languageChanged', syncDocumentLang);
    syncDocumentLang();
  }

  return instance;
}

export { i18n };
export { toManagedLoginLang } from './managedLoginLang';
